import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import './assets/scss/app.scss';
import '@/assets/css/app.css';
import '@/assets/css/materialdesignicons.min.css';

import 'bulma-modal-fx/dist/css/modal-fx.min.css';
import 'material-icons/iconfont/material-icons.css';
import 'bulma-badge/dist/css/bulma-badge.min.css';

import './globalplugins';
import './globalcomponents';
import './globalFilters';
import './globalDirectives';
import VueGtag from "vue-gtag";

//Google Analytics

Vue.use(VueGtag, {
  config: { id: "UA-127161372-2" }
}, router);

//AvatarCropper
import AvatarCropper from "vue-avatar-cropper";

Vue.component('avatar-cropper', AvatarCropper);

// QuillEditor
import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
// End QuillEditor


import Axios from 'axios';
import { clearLegacyPersistentSession, getSessionToken } from '@/helpers/sessionStorage';

Vue.prototype.$http = Axios;
clearLegacyPersistentSession();
const token = getSessionToken()
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
  if (store.getters.isMobile)
    store.commit("setSidebarActive", false);

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login')
    return
  }

  next();
})


// filters
import moment from 'moment';

Vue.filter("LLLL", (value: any) => {
  if (!value) return "";
  return moment(value).format("LLLL");
});

Vue.filter("l", (value: any) => {
  if (!value) return "";
  return moment(value).format("l");
});

Vue.filter("shortTo25", (value: any) => {
  if (!value) return "";
  return value.length > 20 ? value.substring(0, 25) + "..." : value;
});

// end filters

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

